import React from 'react';
import { Link } from 'react-router-dom';
import { ROUTES } from '../utils/constants';

function AboutPage() {
  return (
    <div className="page">
      <div className="container">
        <div className="content-page">
          <h1>About QDN</h1>

          <section className="content-section">
            <p>
              Queer Data Network (QDN) is a community-driven hub for LGBTQ+ people who work with data, tech, research, and adjacent fields. 
              It exists to make it easier to find each other, share knowledge, and build safer, more accountable practices around queer-relevant data.
            </p>

            <p>
              At QDN, "queer data" is not just data about LGBTQ+ people. It includes data created by queer folks, data work informed by 
              queer and trans perspectives, and projects that explicitly center ethics, consent, and the real risks queer communities face 
              when data is mishandled.
            </p>

            <h2>What Members Can Do</h2>
            <ul>
              <li>Browse resources on queer-affirming data practices, ethics, and methods.</li>
              <li>Share guides, reflections, case studies, and event recaps as resource posts.</li>
              <li>Post announcements, events, and discussions on the community board.</li>
              <li>Learn about other queer-friendly communities, conferences, and opportunities in data and tech.</li>
            </ul>

            <p>
              QDN is explicitly queer-affirming, anti-racist, trans-affirming, and opposed to pathologizing or carceral uses of data 
              about queer lives. The space assumes that data work is never "neutral," especially when it touches sexuality, gender, race, 
              disability, migration, or criminalization.
            </p>

            <p>
              Support for QDN helps cover hosting, moderation, and future features, and—over time—can help compensate community members 
              who contribute labor, especially those most impacted by data harms. Financial support is optional; no one is required to pay 
              to participate.
            </p>
          </section>

          <section className="content-section">
            <h2>About the Organizers</h2>
            <p>
              Queer Data Network is organized by queer people working in and around data who have seen how poorly designed data projects 
              can erase, misrepresent, or endanger LGBTQ+ communities. QDN is a small, community-centered project, not a corporate platform 
              or a data-collection pipeline.
            </p>
          </section>

          <section className="content-section cta-section">
            <Link to={ROUTES.GETTING_STARTED} className="btn btn-primary">
              Get Started
            </Link>
            <Link to={ROUTES.CODE_OF_CONDUCT} className="btn btn-outline">
              Read Code of Conduct
            </Link>
          </section>
        </div>
      </div>
    </div>
  );
}

export default AboutPage;
